import { render, staticRenderFns } from "./company-panel-placeholder.vue?vue&type=template&id=4e974641&scoped=true&"
import script from "./company-panel-placeholder.vue?vue&type=script&lang=ts&"
export * from "./company-panel-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./company-panel-placeholder.vue?vue&type=style&index=0&id=4e974641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e974641",
  null
  
)

export default component.exports